import { defineComponent as _defineComponent } from 'vue';
import { useUserStore } from '@/store/modules/user';
import { useSettingsStore } from '@/store/modules/settings';
import { translate } from '@/i18n';

import { storeToRefs } from 'pinia';
import { ref } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props, {
    expose: __expose
  }) {
    __expose();
    const vFocus = {
      mounted(el) {
        el.querySelector('input')?.focus();
      }
    };
    const userStore = useUserStore();
    const {
      avatar
    } = storeToRefs(userStore);
    const settingsStore = useSettingsStore();
    const {
      theme,
      lock,
      title
    } = storeToRefs(settingsStore);
    const {
      handleLock: _handleLock,
      handleUnLock: _handleUnLock
    } = settingsStore;
    const background = ref(`https://gcore.jsdelivr.net/gh/zxwk1998/image/vab-image-lock/${Math.round(Math.random() * 31)}.jpg`);
    const randomBackground = () => {
      background.value = `https://gcore.jsdelivr.net/gh/zxwk1998/image/vab-image-lock/${Math.round(Math.random() * 31)}.jpg`;
    };
    const validatePass = (rule, value, callback) => {
      if (value === '' || value !== '123456') {
        callback(new Error('请输入正确的密码'));
      } else {
        callback();
      }
    };
    const formRef = ref();
    const form = ref({
      password: '123456'
    });
    const rules = {
      password: [{
        validator: validatePass,
        trigger: 'blur'
      }]
    };
    let lockIcon = true;
    const handleUnLock = () => {
      formRef.value.validate(async valid => {
        if (valid) {
          lockIcon = false;
          setTimeout(async () => {
            await _handleUnLock();
            lockIcon = true;
            await randomBackground();
            const el = document.querySelector('.vab-side-bar');
            if (el) el.removeAttribute('style');
          }, 500);
        }
      });
    };
    const handleLock = () => {
      _handleLock();
      const el = document.querySelector('.vab-side-bar');
      if (el) el.style.display = 'none';
    };
    const __returned__ = {
      vFocus,
      userStore,
      avatar,
      settingsStore,
      theme,
      lock,
      title,
      _handleLock,
      _handleUnLock,
      background,
      randomBackground,
      validatePass,
      formRef,
      form,
      rules,
      get lockIcon() {
        return lockIcon;
      },
      set lockIcon(v) {
        lockIcon = v;
      },
      handleUnLock,
      handleLock,
      get translate() {
        return translate;
      }
    };
    Object.defineProperty(__returned__, '__isScriptSetup', {
      enumerable: false,
      value: true
    });
    return __returned__;
  }
});